"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var styles = require("../../../styles/ModelResultStyles");
var NumberUtils_1 = require("../../../util/NumberUtils");
var TestIds_1 = require("../../../util/TestIds");
var Utils_1 = require("../../../util/Utils");
var Index_1 = require("../../base/Index");
var CONTAINER_WIDTH = 500;
var CHART_WIDTH = 436;
var getMetricValidationData = function (modelMetrics, outcomeText) {
    var _a;
    var metricName;
    var accuracy;
    var accuracyDescription;
    var tooltip;
    var barColor;
    switch ((_a = modelMetrics === null || modelMetrics === void 0 ? void 0 : modelMetrics.validation) === null || _a === void 0 ? void 0 : _a.type) {
        case Utils_1.ModelType.Regression:
        case Utils_1.ModelType.RegressionGLM:
            metricName = Localize_1.Messages.modelReviewOverviewRSquareHeader();
            accuracy = (0, NumberUtils_1.formatNumericField)({ value: modelMetrics.validation.r2, fractionDigits: 4 });
            accuracyDescription = Localize_1.Messages.modelResultOverviewScoreDescriptionR2({
                outcomeText: outcomeText,
                score: (0, NumberUtils_1.formatNumericField)({ value: modelMetrics.validation.r2 * 100, fractionDigits: 2, isPercent: true }),
            });
            tooltip = Localize_1.Messages.rSquaredTooltip();
            barColor = prediction_model_results_viz_1.VizColors.chartDefault;
            break;
        case Utils_1.ModelType.Binomial:
        case Utils_1.ModelType.BinomialGLM:
            metricName = Localize_1.Messages.modelReviewOverviewAUCHeader();
            accuracy = (0, NumberUtils_1.formatNumericField)({ value: modelMetrics.validation.auc, fractionDigits: 3 });
            accuracyDescription = Localize_1.Messages.modelResultOverviewScoreDescriptionAUC();
            tooltip = Localize_1.Messages.aucTooltip();
            barColor = prediction_model_results_viz_1.VizColors.background02;
            break;
        default:
            metricName = '-';
            accuracy = '-';
            accuracyDescription = '-';
            tooltip = 'N/A';
            barColor = prediction_model_results_viz_1.VizColors.chartDefault;
            break;
    }
    return { metricName: metricName, accuracy: accuracy, accuracyDescription: accuracyDescription, tooltip: tooltip, barColor: barColor };
};
var ModelResultModelAccuracy = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelOutcome = _a.modelOutcome, modelMetrics = _a.modelMetrics;
    if (!modelOutcome || !modelMetrics) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'model-accuracy' });
    }
    var _b = getMetricValidationData(modelMetrics, modelOutcome.name), metricName = _b.metricName, accuracy = _b.accuracy, accuracyDescription = _b.accuracyDescription, tooltip = _b.tooltip, barColor = _b.barColor;
    var labels = {
        minLabel: Localize_1.Messages.modelResultScoreMinLabel(),
        maxLabel: Localize_1.Messages.modelResultScoreMaxLabel(),
    };
    return (React.createElement(Index_1.Card.Container, { header: metricName, tooltip: tooltip, width: CONTAINER_WIDTH },
        React.createElement("div", { className: styles.OverviewScoreContainer },
            React.createElement("div", { className: styles.OverviewScore }, accuracy),
            React.createElement("div", { className: styles.OverviewScoreDescription }, accuracyDescription),
            React.createElement("div", { className: styles.OverviewScoreChart },
                React.createElement(prediction_model_results_viz_1.ProgressBarComponent, { value: Number(accuracy), labels: labels, width: CHART_WIDTH, bars: { barColor: barColor } })))));
};
exports.default = ModelResultModelAccuracy;
//# sourceMappingURL=ModelResultModelAccuracy.js.map